// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__kBR2j","content":"RecentSearches_content__3d37b"};